var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 51,
    viewBox: "0 0 30 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3305 50.9996C14.5438 50.9996 12.2656 49.6502 12.2656 47.9978C12.2656 46.3454 14.534 44.9961 17.3305 44.9961C20.1269 44.9961 22.3953 46.3454 22.3953 47.9978C22.3953 49.6502 20.1269 50.9996 17.3305 50.9996ZM17.3305 45.3676C14.7394 45.3676 12.6372 46.5507 12.6372 47.9978C12.6372 49.4449 14.7394 50.628 17.3305 50.628C19.9215 50.628 22.0237 49.4449 22.0237 47.9978C22.0237 46.5507 19.9215 45.3676 17.3305 45.3676Z",
    fill: "url(#paint0_linear_2953_26023)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6811 47.7646C20.6811 48.8304 19.1754 49.7006 17.3274 49.7006C15.4794 49.7006 13.9736 48.8304 13.9736 47.7646C13.9736 46.6989 15.4794 45.4082 17.3274 45.4082C19.1754 45.4082 20.6811 46.6989 20.6811 47.7646Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3276 49.8758C15.3427 49.8758 13.7881 48.947 13.7881 47.7541C13.7881 46.5612 15.3623 45.2119 17.3276 45.2119C19.2929 45.2119 20.8671 46.6003 20.8671 47.7541C20.8671 48.9079 19.3125 49.8758 17.3276 49.8758ZM17.3276 45.5835C15.6165 45.5835 14.1596 46.7763 14.1596 47.7639C14.1596 48.7514 15.6165 49.5141 17.3276 49.5141C19.0387 49.5141 20.4956 48.7123 20.4956 47.7639C20.4956 46.8154 19.0289 45.5835 17.3276 45.5835Z",
    fill: "url(#paint1_linear_2953_26023)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4463 45.4463L18.033 47.0596C18.1503 47.1867 18.6685 48.1938 18.9814 49.3867C19.8614 49.064 20.6143 48.5556 20.6143 47.7441C20.6143 46.7174 19.2063 45.4854 17.4463 45.4365V45.4463Z",
    fill: "url(#paint2_linear_2953_26023)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8546 49.6314L18.8057 49.4358C18.4928 48.2527 17.9844 47.2847 17.8964 47.1772L17.8573 47.1185L17.1729 45.251H17.4466C19.3337 45.3194 20.8004 46.6394 20.8004 47.7443C20.8004 48.5167 20.1941 49.1425 19.0404 49.5532L18.8546 49.6216V49.6314ZM18.1995 46.9718C18.3657 47.1967 18.8057 48.0963 19.1088 49.1523C19.7541 48.8883 20.4386 48.4483 20.4386 47.7541C20.4386 46.8838 19.2457 45.8083 17.7204 45.6519L18.1995 46.9718Z",
    fill: "url(#paint3_linear_2953_26023)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.044 47.7546C14.044 48.0773 13.9951 48.1555 14.2396 48.4195C15.0511 46.6302 16.2049 46.3466 16.2049 46.3466L16.3125 45.5742C15.0022 45.9262 14.0538 46.904 14.0538 47.7449L14.044 47.7546Z",
    fill: "url(#paint4_linear_2953_26023)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2876 48.7415L14.1019 48.5459C13.8477 48.2819 13.8477 48.1353 13.8477 47.8908C13.8477 47.8517 13.8477 47.8028 13.8477 47.7539C13.8477 46.7957 14.9036 45.7691 16.2432 45.4073L16.5072 45.3389L16.3507 46.5024L16.2334 46.5317C16.2334 46.5317 15.1579 46.8251 14.3952 48.4971L14.2779 48.7415H14.2876ZM16.077 45.8375C15.0308 46.2091 14.2192 47.0304 14.2192 47.7539C14.2192 47.8126 14.2192 47.8615 14.2192 47.9006C14.2192 47.9593 14.2192 47.9984 14.2192 48.0375C14.8939 46.7566 15.725 46.3264 16.0281 46.2091L16.077 45.8375Z",
    fill: "url(#paint5_linear_2953_26023)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3287 47.7637C18.4573 47.7637 19.3722 47.234 19.3722 46.5805C19.3722 45.9271 18.4573 45.3975 17.3287 45.3975C16.2001 45.3975 15.2852 45.9271 15.2852 46.5805C15.2852 47.234 16.2001 47.7637 17.3287 47.7637Z",
    fill: "#222222"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3289 47.9389C16.0774 47.9389 15.0996 47.3425 15.0996 46.5798C15.0996 45.8171 16.0774 45.2207 17.3289 45.2207C18.5805 45.2207 19.5582 45.8171 19.5582 46.5798C19.5582 47.3425 18.5805 47.9389 17.3289 47.9389ZM17.3289 45.5825C16.3218 45.5825 15.4712 46.042 15.4712 46.5798C15.4712 47.1176 16.3218 47.5771 17.3289 47.5771C18.336 47.5771 19.1867 47.1176 19.1867 46.5798C19.1867 46.042 18.336 45.5825 17.3289 45.5825Z",
    fill: "url(#paint6_linear_2953_26023)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3866 0.449219C17.3279 0.449219 17.2692 0.449219 17.2106 0.449219C17.1812 0.449219 17.1519 0.449219 17.1128 0.449219C15.4506 0.478552 13.5635 1.06521 11.5689 2.30697C5.54583 6.05182 0.588555 14.7344 0.441891 21.7743C0.363669 25.568 1.63477 28.2275 3.71741 29.4986L3.84452 29.5866L8.13691 32.0799C9.35912 33.3119 10.2489 34.9839 10.6791 37.1252L10.904 38.2301C10.9235 38.3376 10.9724 38.4158 11.0213 38.4941V38.5136C11.0213 38.5136 12.2337 41.5838 17.0932 42.1998C17.2595 42.2194 17.4159 42.1118 17.4452 41.9456L22.774 14.2357C23.1749 12.8571 23.4487 11.4784 23.5661 10.1389L24.0256 7.73357L27.3696 5.60205C27.3696 5.60205 23.478 0.439443 17.4061 0.458998L17.3866 0.449219Z",
    fill: "#222222"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1136 42.6306C17.1136 42.6306 17.0451 42.6306 17.0158 42.6306C11.9608 41.9852 10.6506 38.8075 10.6017 38.6706V38.6413C10.543 38.5533 10.4941 38.4457 10.4648 38.3088L10.2399 37.204C9.8488 35.2582 9.04703 33.6449 7.85416 32.4227C7.37505 32.1489 3.65954 29.9881 3.62043 29.9587L3.46399 29.8512C1.16624 28.4432 -0.0657375 25.5686 0.00270602 21.7553C0.149371 14.6176 5.23375 5.71993 11.335 1.9262C13.2221 0.75288 15.0505 0.117336 16.7714 0.0195595L17.1136 0H17.358L17.3874 0.439991V0.00977974H17.4363C23.6255 0.00977974 27.5366 5.10394 27.693 5.31905L27.9766 5.69059L24.3979 7.96879L23.9677 10.1981C23.8602 11.4887 23.5864 12.8967 23.166 14.334L17.8469 42.0048C17.7785 42.3568 17.4656 42.611 17.1136 42.611V42.6306ZM11.4426 38.4359C11.6674 38.9151 12.9679 41.203 17.0256 41.7604L22.3349 14.158C22.7455 12.7403 23.0095 11.391 23.1171 10.1101L23.6255 7.47013L26.7153 5.50482C25.7082 4.36083 22.2664 0.899542 17.446 0.899542H17.1332C15.4905 0.919097 13.6523 1.53509 11.8043 2.67907C5.91819 6.33592 1.01958 14.9109 0.882689 21.7944C0.814245 25.285 1.89956 27.8956 3.95287 29.1472L4.09954 29.245L8.3626 31.7187L8.4506 31.7871C9.79014 33.1365 10.6799 34.9062 11.1101 37.0475L11.335 38.1524C11.335 38.1524 11.3643 38.2208 11.3937 38.2795L11.4621 38.3968V38.4457L11.4426 38.4359Z",
    fill: "url(#paint7_linear_2953_26023)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9685 22.1072L21.5248 8.28158C21.5248 8.28158 19.804 3.44164 11.9525 2.06299C11.8058 2.15099 11.669 2.20965 11.5223 2.29765C6.98546 5.11361 3.05485 10.7358 1.33398 16.3384C1.33398 16.3384 4.74638 20.8165 16.9782 22.1072H16.9685Z",
    fill: "#222222"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2712 22.5766L16.929 22.5375C4.70689 21.2468 1.13804 16.798 0.991379 16.6024L0.854492 16.4264L0.922943 16.2113C2.73181 10.3252 6.80909 4.72258 11.297 1.93595C11.385 1.87728 11.4828 1.82839 11.5708 1.7795C11.6295 1.75017 11.6784 1.72084 11.737 1.6915L11.8739 1.61328L12.0304 1.64261C20.0383 3.0506 21.8667 7.92965 21.9351 8.14475L21.984 8.28164L17.2712 22.5766ZM1.81271 16.2407C2.55581 17.0326 6.38864 20.4842 16.665 21.6379L21.0649 8.30119C20.7227 7.55809 18.6791 3.73503 12.0206 2.51282C12.001 2.5226 11.9815 2.53238 11.9619 2.54216C11.8935 2.58127 11.8152 2.62038 11.7468 2.65949C7.48374 5.30923 3.60202 10.6185 1.81271 16.2309V16.2407Z",
    fill: "url(#paint8_linear_2953_26023)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5415 12.1542C29.5415 4.58634 24.1051 1.62372 17.4954 5.74011C11.4723 9.48495 6.51507 18.1675 6.36841 25.2074C6.28041 29.6562 8.03061 32.57 10.7879 33.4793C13.7016 34.4473 15.843 36.8037 16.5958 40.5486L16.8207 41.6534C16.9283 42.2108 17.4074 42.377 17.9549 42.0641C18.5025 41.7512 18.9718 41.0277 19.0891 40.3432L19.2554 39.3459C20.0082 34.7504 21.9247 29.8029 24.8775 25.5496C27.713 21.4821 29.5415 16.5346 29.5415 12.1347V12.1542Z",
    fill: "#222222"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.437 42.6603C17.2904 42.6603 17.1437 42.631 17.0068 42.5723C16.6939 42.4256 16.4788 42.1421 16.4006 41.751L16.1757 40.6461C15.4815 37.2044 13.5749 34.8675 10.6513 33.8995C7.5616 32.8729 5.84075 29.7049 5.93852 25.2072C6.08519 18.0695 11.1696 9.17185 17.2708 5.37812C20.6441 3.2857 23.8414 2.87504 26.2858 4.23414C28.6716 5.55412 29.9818 8.37009 29.9818 12.1638C29.9818 16.5051 28.2511 21.4917 25.2396 25.8232C22.4334 29.8516 20.4681 34.6817 19.6859 39.4337L19.5197 40.431C19.3828 41.2426 18.8352 42.0737 18.1801 42.455C17.9357 42.6016 17.6815 42.6701 17.4468 42.6701L17.437 42.6603ZM23.1276 4.30258C21.485 4.30258 19.6468 4.90879 17.7304 6.10167C11.8442 9.75851 6.94562 18.3335 6.80873 25.217C6.73051 29.3138 8.22649 32.1787 10.9349 33.0782C14.1224 34.1342 16.293 36.7644 17.0361 40.4701L17.261 41.575C17.2708 41.6337 17.3099 41.751 17.3784 41.7803C17.437 41.8097 17.5739 41.7999 17.7597 41.6923C18.1997 41.4381 18.5908 40.8319 18.6788 40.2746L18.845 39.2772C19.6468 34.3982 21.6708 29.4409 24.5454 25.305C27.42 21.1788 29.1311 16.2509 29.1311 12.1443C29.1311 8.68297 27.9773 6.14078 25.8849 4.97724C25.0636 4.52747 24.1445 4.30258 23.1472 4.30258H23.1276Z",
    fill: "url(#paint9_linear_2953_26023)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5596 21.5099C20.0174 25.9196 15.8814 28.3053 13.3393 26.8387C10.7971 25.3721 10.7971 20.6006 13.3393 16.1908C15.8814 11.7811 20.0174 9.39537 22.5596 10.862C25.1018 12.3287 25.1018 17.1002 22.5596 21.5099Z",
    fill: "#222222"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0401 27.6995C14.3459 27.6995 13.7006 27.5333 13.1237 27.2008C11.7548 26.4088 11.002 24.776 11.002 22.6053C11.002 20.4347 11.7059 18.1565 12.9673 15.9663C14.2384 13.7663 15.9299 11.9868 17.7388 10.9406C19.6161 9.85528 21.4152 9.68906 22.784 10.4811C25.5804 12.0944 25.6489 17.0321 22.9405 21.7254C21.6694 23.9253 19.9778 25.7049 18.169 26.7511C17.0739 27.3866 16.0081 27.6995 15.0401 27.6995ZM20.8676 10.8526C20.0561 10.8526 19.137 11.1362 18.169 11.6837C16.4872 12.6517 14.913 14.3237 13.7201 16.3965C12.5273 18.4694 11.8722 20.6694 11.8722 22.6053C11.8722 24.5413 12.4784 25.8222 13.5637 26.448C14.6588 27.0835 16.145 26.9173 17.7388 25.9884C19.4205 25.0204 20.9947 23.3484 22.1876 21.2756C24.6124 17.081 24.6809 12.5637 22.344 11.2144C21.904 10.9602 21.4054 10.833 20.8578 10.833L20.8676 10.8526Z",
    fill: "url(#paint10_linear_2953_26023)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3247 21.2955L19.0313 20.1711L17.0856 21.2955L16.7825 22.7621L15.0029 23.7888L16.9585 15.7222L19.1193 14.4805L21.0944 20.2786L19.3247 21.2955ZM18.6989 18.8315L18.4447 17.844C18.386 17.6289 18.3078 17.3453 18.2296 16.9933C18.1416 16.6413 18.0829 16.3871 18.0633 16.2307C18.034 16.4067 17.9949 16.7 17.9167 17.1107C17.8482 17.5213 17.682 18.3426 17.4376 19.5649L18.7087 18.8315H18.6989Z",
    fill: "url(#paint11_linear_2953_26023)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2953_26023",
    x1: 12.9354,
    y1: 51.645,
    x2: 22.1213,
    y2: 45.7975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2953_26023",
    x1: 14.2562,
    y1: 50.3773,
    x2: 21.0494,
    y2: 46.4872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2953_26023",
    x1: 17.6558,
    y1: 49.8114,
    x2: 21.3541,
    y2: 48.6924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2953_26023",
    x1: 17.4127,
    y1: 50.1023,
    x2: 21.6242,
    y2: 48.7865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2953_26023",
    x1: 14.1903,
    y1: 48.7254,
    x2: 16.845,
    y2: 47.9255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2953_26023",
    x1: 14.0235,
    y1: 49.1073,
    x2: 17.1414,
    y2: 48.1879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2953_26023",
    x1: 15.3944,
    y1: 48.2311,
    x2: 19.5027,
    y2: 45.6887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2953_26023",
    x1: 1.84984,
    y1: 47.2139,
    x2: 35.4414,
    y2: 38.8969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2953_26023",
    x1: 2.25159,
    y1: 24.8304,
    x2: 25.7754,
    y2: 15.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2953_26023",
    x1: 7.52459,
    y1: 46.8871,
    x2: 36.612,
    y2: 40.1592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2953_26023",
    x1: 11.9227,
    y1: 29.6038,
    x2: 28.233,
    y2: 24.7658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2953_26023",
    x1: 15.4057,
    y1: 24.7896,
    x2: 22.7221,
    y2: 22.9832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.081f1a1cc6025e651f87dc9ccfb7cfd2.svg";
export { ForwardRef as ReactComponent };